export const CountryConstants = {
    colombia: "CO",
}